import { render, staticRenderFns } from "./QuestionarioProntoSocorro.vue?vue&type=template&id=6bcd208a&scoped=true"
import script from "./QuestionarioProntoSocorro.vue?vue&type=script&lang=js"
export * from "./QuestionarioProntoSocorro.vue?vue&type=script&lang=js"
import style0 from "./QuestionarioProntoSocorro.vue?vue&type=style&index=0&id=6bcd208a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bcd208a",
  null
  
)

export default component.exports